import * as React from "react";
import classnames from "classnames";
import { Price } from "@grandvisionhq/common";
/* empty css                        */
const ProductDetailPrice = ({
  originalPrice,
  discountedPrice,
  currency,
  customSize,
  isCentAmount = true,
  className,
  prefix
}) => {
  if (originalPrice && discountedPrice && originalPrice !== discountedPrice) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Price,
      {
        value: discountedPrice,
        currency,
        centAmount: isCentAmount,
        className: classnames("product-detail-price", className),
        size: customSize ?? "large",
        type: "discount",
        "data-t": "price-discounted",
        prefix
      }
    ), /* @__PURE__ */ React.createElement(
      Price,
      {
        value: originalPrice,
        currency,
        centAmount: isCentAmount,
        className: classnames("product-detail-price", className),
        size: customSize ?? "large",
        type: "strikethrough",
        "data-t": "price-original"
      }
    ));
  }
  return /* @__PURE__ */ React.createElement(
    Price,
    {
      value: originalPrice,
      currency,
      centAmount: isCentAmount,
      size: customSize ?? "large",
      className: "product-detail-price",
      "data-t": "price-original",
      prefix
    }
  );
};
export {
  ProductDetailPrice
};
//# sourceMappingURL=ProductDetailPrice.js.map
